/**
 * Display names for the plan keys the api sends (`TenantPlans.PlanName`).
 *
 * The api identifies plans by key only and leaves naming them to the
 * frontend. Translate through here rather than restating the names in a
 * component.
 */
const PLAN_DISPLAY_NAMES: Record<string, string> = {
  FREE_STARTER_PLAN: 'Free Starter',
  PAID_STARTER_PLAN: 'Paid Starter',
  STANDARD_PLAN: 'Standard',
  PRO_PLAN: 'Pro',
  FOUNDING_MEMBER_PLAN: 'Founding Member',
}

/**
 * Plans a super user can move a tenant onto. This mirrors the api's plan keys
 * (`SynkedUp.Domain/FeatureGrants/Plans.cs`), which offers no list of assignable
 * plans to read, so it must change alongside them.
 */
const ASSIGNABLE_PLAN_NAMES = [
  'FREE_STARTER_PLAN',
  'PAID_STARTER_PLAN',
  'STANDARD_PLAN',
  'PRO_PLAN',
  'FOUNDING_MEMBER_PLAN',
]

export type PlanOption = {
  label: string
  value: string
}

/** A plan without a display name here reads as its key: recognisable, never blank. */
export function getPlanDisplayName(planName: string): string {
  return PLAN_DISPLAY_NAMES[planName] ?? planName
}

/**
 * The assignable plans, plus the tenant's current plan when it is not one of
 * them, so a tenant still on a retired plan shows it instead of a blank select.
 */
export function getPlanOptions(currentPlanName: string): PlanOption[] {
  const planNames = !currentPlanName || ASSIGNABLE_PLAN_NAMES.includes(currentPlanName)
    ? ASSIGNABLE_PLAN_NAMES
    : [...ASSIGNABLE_PLAN_NAMES, currentPlanName]

  return planNames.map(planName => ({ label: getPlanDisplayName(planName), value: planName }))
}
